import { ListingQueryModel } from './listing-query'

/**
 * @memberOf loavies.models.listing
 * @constructor
 */

export class OperatorListingQueryModel extends ListingQueryModel{
  /**
   * https://www.sharetribe.com/api-reference/marketplace.html#query-listings
   * @param {string} [authorId]
   * @param {string|string[]} [ids] Comma separated list or array with strings
   * @param {string} [keywords]
   * @param {string} [price] (integer or integer range) Match only listings with price amount within given range.
   * @param {string} [start] Start time of the availability interval to match listings against in ISO 8601 format
   * @param {string} [end] The end time must be after the start time and must be at most 365 days in the future or at most 90 days from the start time (whichever comes sooner)
   * @param {Object} [publicData] key: publicData attribute, value query syntax: https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
   * @param {Object} [metaData] key: metaData attribute, value query syntax: https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
   * @param {string} [sort] https://www.sharetribe.com/api-reference/marketplace.html#sorting
   * @param {number} [minStock]
   * @param {string[]} [states] Comma separated list or array with strings
   * @param {string} [createdAtStart] An ISO 8601 Date Time Stamp
   * @param {string} [createdAtEnd] An ISO 8601 Date Time Stamp
   */
  constructor({
    ids,
    authorId,
    keywords,
    price,
    start,
    end,
    publicData,
    metaData,
    sort,
    minStock,
    states,
    createdAtStart,
    createdAtEnd,
  }) {
    super({
      ids,
      authorId,
      keywords,
      price,
      start,
      end,
      publicData,
      metaData,
      sort,
      minStock,
    })

    /** @type {string[]} */
    this.states = states

    /** @type {string} */
    this.createdAtStart = createdAtStart

    /** @type {string} */
    this.createdAtEnd = createdAtEnd
  }
}
